<div class="row d-flex">
    <div class="col-md-10 divSearch">
        <app-search [list]="ContractsList" [OriginalList]="OriginalContractsList" [column]="'clientName'"
            (newItemEvent)="GetFilteredList($event)"></app-search>
    </div>
</div>

<div class="count" *ngIf="ContractsList.length!=0">{{'Results'| translate}}: {{ContractsList.length}}</div>
<div class="row">
    <div *ngIf="ContractsList.length==0;then NoContracts else Contracts"></div>

    <ng-template #NoContracts>
        <div class="col-md-12">
            <p> {{ 'NoDataFound' | translate }}</p>
        </div>
    </ng-template>

    <ng-template #Contracts>
        <div class="col-lg-4 col-sm-4 m-b-15" *ngFor="let contract of ContractsList">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                    <mat-card-title class="mat-mdc-card-title text-white">
                        {{ contract.clientName| subString:20}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content class="mat-mdc-card-content text-center">
                    <div class="row">
                        <div class="col-md-12">
                            <table class="table w-100">
                                <tbody>
                                    <tr>
                                        <td>
                                            <i-tabler name="map-pins" class="icon-15 d-flex icon"></i-tabler>
                                        </td>
                                        <td><span class="span-title">{{ 'Address' | translate }} </span></td>
                                        <td><span>{{ contract.address | subString:20 }}</span></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <i-tabler name="Phone" class="icon-15 d-flex icon"></i-tabler>
                                        </td>
                                        <td><span class="span-title">{{ 'Phone' | translate }}</span></td>
                                        <td><span> {{ contract.workShopPhone }}</span></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <mat-divider></mat-divider>
                                    <tr class="trBtn">
                                        <td>
                                            <a [routerLink]="['/dashboard/modify-payments/'+contract.id]"
                                                class="btnModifyPayments">
                                                {{ 'ModifyPayments' | translate}}
                                            </a>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </ng-template>
</div>